import {
    BOOKING_ATTEMPT_ERROR,
    BOOKING_ATTEMPT_SAVE_START,
    BOOKING_ATTEMPT_SAVE_SUCCESS,
    BookingAttemptAction
} from 'actions/bookingAttempts/BookingAttemptsActionsTypes';
import {
    convertToBookingAttempt,
    convertToSaveBookingAttemptDto
} from 'actions/bookingAttempts/BookingAttemptsConverter';
import { BookingAttemptDto } from 'actions/bookingAttempts/BookingAttemptsDtos';
import {
    BookingAttemptError,
    BookingAttemptErrorType
} from 'actions/bookingAttempts/BookingAttemptsError';
import { ApiClient, createTokenConfig } from 'api/ApiClient';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { BookingAttempt, SaveBookingAttempt } from 'types/BookingAttempt';
import { getFirstAxiosError } from 'utils/axiosHelper';
import { v4 as uuid } from 'uuid';

const bookingAttemptsUrl = '/booking_attempts';

const errorHandler = (error: unknown): BookingAttemptAction => {
    console.error(error);

    return {
        type: BOOKING_ATTEMPT_ERROR
    };
};

const saveBookingAttemptStart = (): BookingAttemptAction => ({ type: BOOKING_ATTEMPT_SAVE_START });

const saveBookingAttemptSuccess = (bookingAttempt: BookingAttempt): BookingAttemptAction => ({
    type: BOOKING_ATTEMPT_SAVE_SUCCESS,
    payload: {
        bookingAttempt
    }
});

export const saveBookingAttemptThunk = (
    bookingAttempt: SaveBookingAttempt
): ThunkAction<Promise<BookingAttempt>, RootState, null, RootAction> => {
    return async dispatch => {
        try {
            dispatch(saveBookingAttemptStart());

            let url = `${bookingAttemptsUrl}`;

            const apiMethod = bookingAttempt.sessionId ? ApiClient.patch : ApiClient.post;

            if (bookingAttempt.sessionId) {
                url += `/${bookingAttempt.sessionId}`;
            }

            const response = await apiMethod<BookingAttemptDto>(
                url,
                convertToSaveBookingAttemptDto(bookingAttempt.sessionId ?? uuid(), bookingAttempt),
                createTokenConfig()
            );

            dispatch(saveBookingAttemptSuccess(convertToBookingAttempt(response.data)));

            return convertToBookingAttempt(response.data);
        } catch (error) {
            dispatch(errorHandler(error));

            const errorMessage = getFirstAxiosError(error, 'Oops, something went wrong.');

            throw new BookingAttemptError(BookingAttemptErrorType.Unknown, errorMessage);
        }
    };
};
